import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
import { Card } from '@/components/ui/card';

const Testimonials = () => {
  const testimonials = [
    {
      name: "Marcus T.",
      age: 28,
      location: "Los Angeles, CA",
      rating: 5,
      text: "This app changed my dating game! Found out I'm an 8.7 with Latina women and got specific tips. Grew a beard like they suggested and my matches tripled!",
      avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop"
    },
    {
      name: "David K.",
      age: 32,
      location: "Miami, FL",
      rating: 5,
      text: "The regional breakdown was eye-opening. I'm way more attractive in Miami (8.1) than I thought. The demographic insights helped me understand my appeal better.",
      avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop"
    },
    {
      name: "James R.",
      age: 25,
      location: "New York, NY",
      rating: 5,
      text: "Best $9.99 I ever spent! The personalized grooming tips for different demographics are gold. Actually scientific and honest feedback.",
      avatar: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop"
    },
    {
      name: "Alex M.",
      age: 30,
      location: "Chicago, IL",
      rating: 5,
      text: "Monthly Pro is worth it! Getting new strategies every month based on who I want to attract. My confidence has skyrocketed.",
      avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop"
    }
  ];

  return (
    <div className="py-12">
      <div className="text-center mb-12">
        <motion.h3 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-5xl font-bold mb-4 bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent"
        >
          What Our Users Say
        </motion.h3>
        <p className="text-2xl text-gray-300">Real results from real people</p>
      </div>

      <div className="grid md:grid-cols-2 gap-6 max-w-6xl mx-auto">
        {testimonials.map((testimonial, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            whileHover={{ scale: 1.02 }}
          >
            <div className="bg-white/5 backdrop-blur-xl rounded-2xl p-8 border border-white/10 hover:bg-white/10 transition-all h-full">
              <div className="flex items-start gap-4 mb-6">
                <img 
                  src={testimonial.avatar} 
                  alt={testimonial.name}
                  className="w-16 h-16 rounded-full object-cover ring-4 ring-purple-400/50"
                />
                <div className="flex-1">
                  <h4 className="font-bold text-xl text-white">{testimonial.name}</h4>
                  <p className="text-sm text-gray-400">{testimonial.age} • {testimonial.location}</p>
                  <div className="flex gap-1 mt-2">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} className="h-4 w-4 fill-yellow-400 text-yellow-400" />
                    ))}
                  </div>
                </div>
                <Quote className="h-10 w-10 text-purple-400/30" />
              </div>
              <p className="text-gray-300 leading-relaxed text-lg">"{testimonial.text}"</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Testimonials;